/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { bool, string, object } from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';

const styles = () => ({
    img: {
        width: '100%',
    },
    roundImg: {
        borderRadius: '3px',
    },
});

const imageTypes = ['t', 'z', 'l', 'c', 'x'];

const imageSrcBuilder = (imagePath, imageName, typeImg = '') => {
    let imageURL = `https:${imagePath}${imageName}`;

    if (typeImg !== '') {
        const imageTypeJPG = imageURL.lastIndexOf('.jpg');
        if (imageTypeJPG > 0) {
            const imageSrcType = imageURL.charAt(imageTypeJPG - 1);
            if (imageTypes.includes(imageSrcType)) {
                imageURL = imageURL.replace('t.jpg', `${typeImg}.jpg`);
            } else {
                imageURL = imageURL.replace('.jpg', `${typeImg}.jpg`);
            }
        } else {
            imageURL = `${imageURL}${typeImg}.jpg`;
        }
    } else {
        imageURL = `${imageURL}${typeImg}.jpg`;
    }

    return imageURL;
};

const ItemImage = (props) => {
    const {
        classes,
        roundedCorner,
        imagePath,
        imageName,
        typeImg,
    } = props;
    let { src } = props;
    const imgClasses = (roundedCorner) ? `${classes.img} ${classes.roundImg}` : classes.img;
    if (imagePath && imageName) {
        src = imageSrcBuilder(imagePath, imageName, typeImg);
    }
    return (
        <img
            className={imgClasses}
            src={src}
            alt="product"
        />
    );
};

ItemImage.defaultProps = {
    src: '',
    classes: {},
    roundedCorner: false,
    imagePath: '',
    imageName: '',
    typeImg: '', // type images: t, z, l, c, x
};

ItemImage.propTypes = {
    src: string,
    classes: object,
    roundedCorner: bool,
    imagePath: string,
    imageName: string,
    typeImg: string,
};

export default withStyles(styles)(ItemImage);
